import { Checkbox, CheckboxProps } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import { ReactComponent as Checked } from '@Images/icons/checked.svg'
import { ReactComponent as Unchecked } from '@Images/icons/unchecked.svg'
import { $primaryColor } from '@Styles/colors'

export const BaseCheckBox = withStyles({
    root: {
        color: 'gray',
        '&$checked': {
            color: $primaryColor,
        },
    },
    checked: {},
})((props: CheckboxProps) => (
    <>
        <Checkbox
            color="default"
            // icon={<Unchecked />}
            // checkedIcon={<Checked/>}
            size="medium"
            {...props}
        />
    </>
))
